import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SCENE_IMAGE_ADULT, audienceItems, timeValueTasks } from '../data/drum';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="3p2f8u2li4l1c">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="6wapk4j836ez">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1vd85u61egej">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-22" data-mp="1ubpb3is4pm9">
            Who is <em className="text-red-700" data-id="element-23" data-mp="gqkjvrrq6esc">DRUM READY™</em> for?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-24" data-mp="btkd1en1x806">This package is for you if you:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-25" data-mp="pnbncp8lwvwy">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-26" data-mp="llzxciltm8o8">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="ukk4cmi0qtwm" />
                {item}
              </li>)}
          </ul>
          <img src={SCENE_IMAGE_ADULT} alt="A drum teacher counting along while an adult student plays a groove" loading="lazy" className="mt-10 block aspect-[4/3] w-full rounded-3xl border border-slate-900/10 object-cover shadow-xl shadow-slate-900/10" data-id="element-28" data-mp="16fb3cn6klks1" />
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-29" data-mp="1kdsk20y25x0g">
            Made for drum teachers who want to spend less time preparing and more time teaching.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-30" data-mp="1u9cgcogjaxpq">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-31" data-mp="1z25l3cc0661t">What is your time worth?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-32" data-mp="240709m6b5l80">
            Think about how many hours you spend every week on:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-33" data-mp="2d159civlsixg">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-34" data-mp="cynn95kddf4d">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-35" data-mp="8yv6w6oqi4og">
            Now imagine one organized package that helps with all of it – the whole studio year.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-36" data-mp="hy067f84e21o">
            You don’t have to keep starting from zero.
          </p>
        </aside>
      </div>
    </section>;
}